// extracted by mini-css-extract-plugin
module.exports = {"styledInput":"SearchInput_styledInput__10Siw","inputContainer":"SearchInput_inputContainer__5Srgq","icon":"SearchInput_icon__27oVM"};